module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "padding-top": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "35px",
      "font-weight": "bold"
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Enter the group id to generate report:\n\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gid),
      expression: "gid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Group ID"
    },
    domProps: {
      "value": (_vm.gid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary get-logs",
    class: {
      'disabled': _vm.gid.trim().length === 0
    },
    on: {
      "click": function($event) {
        _vm.downloadReport()
      }
    }
  }, [_vm._v("Download Report")])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17c86ae4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c86ae4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Reports.vue
// module id = 703
// module chunks = 1